<script setup lang="ts">
import type PixKeys from '@/components/user/account/BankAccounts/PixKeys.vue';

const pixKeysRef = ref<InstanceType<typeof PixKeys> | null>(null);

const { userBankAccounts } = useUserData();
const { isBankAccountEnabled } = useFeatureFlagsJson();

const isBankAccountVisible = computed(
  () =>
    !isFormVisible.value &&
    userBankAccounts.value.length &&
    isBankAccountEnabled.value,
);

const selectedBankAccountId = defineModel<number>('modelValue', {
  required: false,
});

const isFormVisible = ref<boolean>(false);

// function onCreateNewOption() {
//   isFormVisible.value = true;
// }

// ENG-868: o saque saiu do <BaseModal> — quem diz que estamos no fluxo de
// saque agora é o useWithdrawModal (este componente é usado tanto na Minha
// Conta quanto dentro do modal).
const isWithdraw = computed(() => isWithdrawFlowOpen.value);

defineExpose({
  pixKeysRef,
});
</script>

<template>
  <div :class="$style.bankAccountsPicker">
    <div
      v-if="isBankAccountVisible"
      :class="$style.formGroup"
    >
      <label
        class="inline-flex mb-2 font-semibold"
        for="fieldType"
      >
        {{
          isWithdraw
            ? $t('account.user_data.bank_accounts_withdraw')
            : $t('account.user_data.bank_accounts')
        }}
      </label>

      <UserAccountBankAccountsList
        v-model="selectedBankAccountId"
        pickable
      />

      <!-- <span @click="onCreateNewOption">Adicionar nova chave pix</span> -->
    </div>

    <template v-else>
      <button
        v-if="isBankAccountVisible"
        @click="isFormVisible = false"
      >
        <span>
          {{ $t('general.cancel') }}
        </span>
      </button>

      <UserAccountBankAccountsPixKeys
        ref="pixKeysRef"
        :show-save-button="false"
      />
    </template>
  </div>
</template>

<style module lang="postcss">
.formGroup {
  @apply flex-1 w-full relative min-w-[50%] md:min-w-[20%];

  label {
    @apply text-xs font-medium;
  }
}

.combobox {
  @apply flex flex-col;
}
</style>
